import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { reportSearchFrom } from '@/features/accounting-reports/api'
import { ReportViewer } from '@/features/accounting-reports/report-viewer'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/reports/$reportToken')({
  validateSearch: (search: Record<string, unknown>) => reportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view'))
      throw redirect({ to: '/accounting' })
  },
  component: ReportTokenRoute,
})

function ReportTokenRoute() {
  const { reportToken } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  return (
    <ReportViewer
      reportToken={reportToken}
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
    />
  )
}
